import React, { useEffect } from "react";

import { DataBoxGroup } from "@transfr-inc/dashboard-components";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

const ChartFilter = {
  ActiveTrainee: {
    key: "uniqueTraineeCount",
    label: `Active ${getLearnerTerm({ plural: true })}`,
  },
  SimsMastered: {
    key: "simsMastered",
    label: "Sims Mastered",
  },
  SimsCompleted: {
    key: "simsCompleted",
    label: "Sims Completed",
  },
};

export function DashboardDataboxes({ data, onCategoryChange }) {
  const dataBoxConfig = [
    {
      label: ChartFilter.ActiveTrainee.label,
      key: ChartFilter.ActiveTrainee.key,
      alt: "Icon for a user avatar wearing a hardhat.",
      description: `${getLearnerTerm({
        plural: true,
      })} who have started at least one sim during the time period.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.ActiveTrainee),
    },
    {
      label: ChartFilter.SimsCompleted.label,
      key: ChartFilter.SimsCompleted.key,
      alt: "Icon for a checkmark within a circle.",
      description: `Sims taken where ${getLearnerTerm({
        lowercase: true,
        plural: true,
      })} have reached the end.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.SimsCompleted),
    },
    {
      label: ChartFilter.SimsMastered.label,
      key: ChartFilter.SimsMastered.key,
      alt: "Icon for a medal.",
      description: "Sims completed with scores of 90% or higher.",
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.SimsMastered),
    },
  ];

  useEffect(() => {
    dataBoxConfig[0].onClick();
  }, []);

  return (
    <DataBoxGroup data={data} dataBoxConfig={dataBoxConfig} className="rows" />
  );
}
